import React from 'react';
import './App.css';
import {ThemeProvider} from "@mui/material";
import theme from "src/theme";
import {ZsForm} from "src/components/molecules/form";
import {DynamicIframe} from "src/dynamicIframe";

function App() {

    return (
        <>
            <div style={{margin: 'auto'}}>
                <ThemeProvider theme={theme}>
                    <DynamicIframe>
                        <ZsForm/>
                    </DynamicIframe>
                </ThemeProvider>
            </div>
        </>
    )
}

export default App;
